// ONBOARDING SIGNALS — the ONE presentation-only seam between TWS's live workspace and the onboarding layer. A window event; never
// pedagogical state, never written anywhere. The workspace reports what happened; the onboarding layer decides whether an introduction is due.
export const ONBOARDING_SIGNAL = "tws-onboarding";
export const onboardingSignal = (kind, detail = {}) => {
  try { window.dispatchEvent(new CustomEvent(ONBOARDING_SIGNAL, { detail: { kind, ...detail } })); } catch { /* ignore */ }
};
